import { is } from '@common/is/is'

import type { TMimeType } from '../definitions'

// Ezen csak teszteljük a format supportot.
const SUPPORT_AUDIO = document.createElement('audio')

/**
 * Le tudjuk-e játszani az adott formátumú hangfájlt.
 * @param mt - A hangfájl típusa.
 */
export default function canPlayMimeType (mt: TMimeType): boolean {
  /**
   * Szánalmas, de itt egy boolean-t várnál erre nem azt kapsz.
   * @example
   * "" | "maybe" | "probably"
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
   */
  const res = SUPPORT_AUDIO.canPlayType(mt)

  // Biztosan le tudja játszani!
  if (res === 'probably') {
    return true
  }

  // Nincs elég információ, amíg le nem játszunk egy hangot.
  if (res === 'maybe') {
    return false
  }

  // Biztos, hogy nem tudja lejátszani a választott típust.
  // Ne üres stringre vizsgálj, mert TS vernyákol!
  if (is.string(res)) {
    return false
  }

  // Készüljünk fel bármire :)
  return false
}
